/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */

export enum ListMonitoringEntriesQueryControllerListCheckSlug {
  "emergency-lighting" = "emergency-lighting",
  "fire-alarm-weekly-test" = "fire-alarm-weekly-test",
  "fire-door-inspection" = "fire-door-inspection",
  "fire-extinguisher-check" = "fire-extinguisher-check",
  "emergency-light-flick-test" = "emergency-light-flick-test",
  "emergency-light-visual-check" = "emergency-light-visual-check",
  "fire-drill" = "fire-drill",
}
